export class GisRequest {
  ExtraPassword: string;
  PlaceHolder: string;
}
